import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { strategyService } from './strategyService';
import { PaymentsPanel } from '../pricing/components/PaymentsPanel';
import { theme } from '../../design/theme';

// Assume useBalanceSync is moved or kept as a hook
// For now, I'll mock it or assume it's available
const useBalanceSync = () => ({ balance: null, notifications: [] });

export const UserPanel: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { balance: liveBalance, notifications } = useBalanceSync();
  const [summary, setSummary] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserSummary = async () => {
      try {
        const data = await strategyService.getUserPanelData();
        setSummary(data);
      } catch (err) {
        console.error('Failed to fetch user summary', err);
      } finally {
        setLoading(false);
      }
    };
    fetchUserSummary();
  }, []);

  if (loading) return <div>Loading My Panel...</div>;
  if (!summary) return <div>No summary data</div>;

  const currentBalance = liveBalance !== null ? liveBalance : summary.token_balance;

  return (
    <div className="user-panel">
      <div className="balance-section">
        <h3>My Balance</h3>
        <div className="balance-display">
          <span className="tokens">{currentBalance.toLocaleString()} Tokens</span>
          {user?.visibility === 'FULL' && (
            <span className="rupees">₹{summary.wallet_balance_inr}</span>
          )}
        </div>
        <button className="btn-topup" onClick={() => navigate('/user/checkout')}>Top-up Wallet</button>
      </div>

      <div className="panel-grid">
        <section className="usage-history">
          <h4>Recent Activity</h4>
          <ul>
            {summary.recent_usage.map((u: any) => (
              <li key={u.id}>
                {u.feature_name} - {u.tokens_consumed} tokens
                <span className="time">{new Date(u.created_at).toLocaleDateString()}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="subscriptions">
          <h4>My Subscription</h4>
          <div className="sub-card">
            <label>{summary.subscription.plan_name}</label>
            <span>Status: {summary.subscription.status}</span>
            <span>Renews: {new Date(summary.subscription.next_renewal).toLocaleDateString()}</span>
          </div>
          {summary.upgrade_suggestion && (
            <div className="upgrade-promo">
              <p>{summary.upgrade_suggestion.message}</p>
              <button className="btn-upgrade">Upgrade Now</button>
            </div>
          )}
        </section>

        <section className="notifications">
          <h4>Alerts</h4>
          <div className="notification-list">
            {(notifications as any[]).map((n, i) => (
              <div key={i} className={`notification-item ${n.type.toLowerCase()}`}>
                <strong>{n.type}</strong>
                <p>{n.message}</p>
              </div>
            ))}
            {notifications.length === 0 && <p>No new alerts.</p>}
          </div>
        </section>
      </div>

      <div style={{ marginTop: theme.spacing.xl }}>
        <PaymentsPanel />
      </div>
    </div>
  );
};
